import React from "react";
import { motion } from "framer-motion";
import { IconArch, IconInterior, IconRender, IconFacade, IconApproval } from "./ServiceIcons";

const SERVICES = [
  {
    icon: IconArch,
    title: "Architectural Design",
    desc: "From massing studies to construction-ready drawings for residential towers and bungalows.",
    testId: "service-card-arch",
    n: "01",
  },
  {
    icon: IconInterior,
    title: "High-End Interior Layouts",
    desc: "Highlighting rich textures, custom wall paneling, and perfectly balanced warm LED profile lighting.",
    testId: "service-card-interior",
    n: "02",
  },
  {
    icon: IconRender,
    title: "Photorealistic 3D Rendering",
    desc: "Uncompromising visual quality featuring advanced global illumination and true-to-life PBR materials.",
    testId: "service-card-render",
    n: "03",
  },
  {
    icon: IconFacade,
    title: "Facade & Material Detailing",
    desc: "Specializing in precise ACP cladding, custom louvers, and bespoke geometric jali screens.",
    testId: "service-card-facade",
    n: "04",
  },
  {
    icon: IconApproval,
    title: "Approval Drawings & Liaisoning",
    desc: "We prepare comprehensive approval drawings and provide end-to-end liaisoning support to streamline the statutory approval and sanction process.",
    testId: "service-card-approval",
    n: "05",
  },
];

export const Services = () => {
  return (
    <section id="services" className="relative bg-[#0F0914] bg-grid-dark text-white">
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-24 md:py-32">
        <div className="max-w-3xl">
          <span className="text-[#c99] text-xs md:text-sm tracking-[0.3em] uppercase font-semibold brand-gradient-text">
            Services & Expertise
          </span>
          <h2 className="mt-5 font-display font-black uppercase tracking-tight leading-[0.98] text-white text-3xl md:text-5xl text-balance">
            Five disciplines. One obsessive standard.
          </h2>
          <p className="mt-6 text-[#B3A8B8] text-base md:text-lg leading-relaxed">
            Every project passes through our integrated pipeline — engineered for precision at
            architectural scale and intimacy at interior detail.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.testId}
                data-testid={s.testId}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: i * 0.1 }}
                className="group relative rounded-2xl border border-white/10 bg-white/[0.03] p-8 hover:bg-white/[0.06] transition-colors duration-300 overflow-hidden"
              >
                <div className="absolute top-0 left-0 h-1 w-0 group-hover:w-full brand-gradient transition-all duration-500" />
                <span className="font-display font-black text-white/10 text-5xl absolute top-6 right-6 select-none">
                  {s.n}
                </span>
                <div className="w-14 h-14 rounded-xl brand-gradient flex items-center justify-center shadow-lg shadow-[#c85a54]/20 text-white">
                  <Icon width={28} height={28} />
                </div>
                <h3 className="mt-7 font-display font-bold uppercase tracking-tight text-white text-lg leading-snug">
                  {s.title}
                </h3>
                <p className="mt-4 text-[#B3A8B8] text-sm leading-relaxed">{s.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
